module.exports = __webpack_public_path__ + "static/media/logo-letus-colour-white-text-new.825d3448.png";